import React from 'react';
import ReadMore from 'components/ReadMore';
import LinkParser from 'helpers/link-parser.js';

import './styles.css';

const TypeFeedHighlight = props => {
  const {
    post: { NewsFeedDateAdd, Records },
    actions: { handleClickNewsLink },
  } = props;
  const highlight = Records[0];
  const news = Records.slice(1);
  const link = LinkParser.getFirmLinkOrigin(highlight.Url);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <span className="feed-post-content__hero">GoBuyside</span>
      </div>

      <div className="feed-post-content__date">{NewsFeedDateAdd}</div>

      <div className="feed-post-content__content-middle">
        <div className="feed-post-content__article">
          <h4 className="feed-post-content__article-title">
            <a href={highlight.Url} target="_blank" rel="noopener noreferrer">
              {highlight.Title}
            </a>
          </h4>
          <span className="feed-post-content__link">{link}</span>

          {highlight.Image ? (
            <figure className="feed-post-content__featured-image">
              <img
                className="feed-post-content__featured-image-img"
                src={highlight.Image}
                alt={highlight.Title}
              />
            </figure>
          ) : (
            <div className="feed-post-content__featured-no-img" />
          )}
          <div className="feed-post-content__truncated-text">
            <ReadMore text={highlight.Content} readMoreCharacterLimit={200} />
          </div>
        </div>
        <div className="feed-post-content__records">
          {news.map((record, i) => (
            <div className="feed-post-content__record" key={i}>
              {record.Image && (
                <a
                  href={record.Url}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="feed-post-content__record-thumb"
                >
                  <img
                    className="feed-post-content__record-thumb-img"
                    src={record.Image}
                    alt={record.Title}
                  />
                </a>
              )}

              <div className="feed-post-content__record-content">
                <a
                  href={record.Url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="feed-post-content__record-title"
                >
                  {record.Title}
                </a>
                <span className="feed-post-content__record-date">
                  {record.DateAdd}
                </span>
                <div>
                  <span className="feed-post-content__link">
                    {LinkParser.getFirmLinkOrigin(record.Url)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="feed-post-content__bottom">
          <span
            className="feed-post-content__records-link"
            onClick={handleClickNewsLink}
          >
            See All News
          </span>
        </div>
      </div>
    </div>
  );
};

export default TypeFeedHighlight;
